export function OutlineUrbanosIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11V18H17.73C17.38 17.4 16.74 17 16 17C15.26 17 14.62 17.4 14.27 18H7.73C7.38 17.4 6.74 17 6 17C5.26 17 4.62 17.4 4.27 18H3V11H21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 19C8 20.1 7.1 21 6 21C4.9 21 4 20.1 4 19C4 18.64 4.1 18.29 4.27 18C4.62 17.4 5.26 17 6 17C6.74 17 7.38 17.4 7.73 18C7.9 18.29 8 18.64 8 19Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18 19C18 20.1 17.1 21 16 21C14.9 21 14 20.1 14 19C14 18.64 14.1 18.29 14.27 18C14.62 17.4 15.26 17 16 17C16.74 17 17.38 17.4 17.73 18C17.9 18.29 18 18.64 18 19Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M5 3H21V11H3V5C3 3.89 3.9 3 5 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3V11"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 3V11"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14H4.94"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
